import {
  ACTIVITIES_DND_TYPE,
  REQUEST_PROFILE_TAB_ACTIVITIES_PHASE_DND_ENABLED,
} from '../RequestProfileTabActivities.constants'
import { useRequestProfileTabActivitiesSortableItem } from '../RequestProfileTabActivities.hooks'
import { getPhaseDndId } from '../RequestProfileTabActivities.utils'
import { RequestProfileTabActivitiesDragHandle } from '../RequestProfileTabActivitiesDragHandle'
import { RequestProfileTabActivitiesPhase } from '../RequestProfileTabActivitiesPhase'

import * as styles from './RequestProfileTabActivitiesSortablePhase.module.css'

function RequestProfileTabActivitiesSortablePhase({
  canEditActivities,
  isOpen,
  permissions,
  phase,
  ...restProps
}) {
  const isDndEnabled =
    REQUEST_PROFILE_TAB_ACTIVITIES_PHASE_DND_ENABLED && canEditActivities

  const { attributes, dropIndicator, listeners, setNodeRef, style } =
    useRequestProfileTabActivitiesSortableItem({
      data: { isOpen, phase, type: ACTIVITIES_DND_TYPE.phase },
      disabled: !isDndEnabled,
      id: getPhaseDndId(phase.id),
      type: ACTIVITIES_DND_TYPE.phase,
    })

  return (
    <div
      className={styles.sortablePhase}
      data-drop-indicator={dropIndicator}
      ref={setNodeRef}
      style={style}
    >
      {isDndEnabled ? (
        <RequestProfileTabActivitiesDragHandle
          className={styles.dragHandle}
          dragHandleProps={{ ...attributes, ...listeners }}
        />
      ) : null}
      <RequestProfileTabActivitiesPhase
        {...restProps}
        canEditActivities={canEditActivities}
        isOpen={isOpen}
        permissions={permissions}
        phase={phase}
      />
    </div>
  )
}

export default RequestProfileTabActivitiesSortablePhase
